import React,{ useContext, useEffect, useState } from "react";
import { AxiosInstance, DialogType, FormActions } from "../utils/constants";
import { AutoCompleteInputWithLabel, InputWithLabel, SelectInputWithLabel } from "../components/form/custom-imputs";
import  * as yup from "yup";
import { ActionTypes, AppContext } from "../store/AppStore";

const validateDatosBasicos  = yup.object({
    tipo_persona:yup.string().required(),
    clasificacion_cliente:yup.string().required(),
    razon_social:yup.string().required(),
    numero_documento:yup.string().required(),
    tipo_documento:yup.string().required(),
    correo:yup.string().email().optional().notRequired().nullable(),
    telefono:yup.string().max(10,"Escriba el numero de telefono sin dijito de verificación").required(),
    nombre_sucursal:yup.string().required(),
    municipio:yup.mixed().required(),
    barrio:yup.mixed().required(),
});


export const useClientCreationPedido = ({callbackOnCreate=()=>{},maestrosCompartidos={}})=>{

  
    const {dispatch,store:{profile}} = useContext( AppContext );
    const configuracionApp = profile.configuracion_comp? JSON.parse(profile.configuracion_comp):{};
    const [ciudades,setCiudades] = useState([]);
    const [barrios,setBarrios] = useState([]);

    useEffect(()=>{
     
    },[]);



   const onSendFormClient = (formData)=>{
    let newFormData = {...formData,creado_por_admin:'SI'};
     if (newFormData.tipo_persona === 'NATURAL'){
      const SplitedRazon = String(formData.razon_social).split(" ");
      formData.razon_social = '';
      if ( SplitedRazon.length > 4 ){
        newFormData.nombres = `${SplitedRazon[0]} ${SplitedRazon[1]}`;
        newFormData.apellidos = `${SplitedRazon[2]} ${SplitedRazon[3]}`;
      }
      if ( SplitedRazon.length == 3 ){
        newFormData.nombres = `${SplitedRazon[0]}`;
        newFormData.apellidos = `${SplitedRazon[1]} ${SplitedRazon[2]}`;
      }
      if ( SplitedRazon.length == 2 ){
        newFormData.nombres = `${SplitedRazon[0]}`;
        newFormData.apellidos = `${SplitedRazon[1]}`;
      }
      if ( SplitedRazon.length == 1 ){
        newFormData.nombres = `${SplitedRazon[0]}`;
        newFormData.apellidos = `${SplitedRazon[0]}`;
      }
      newFormData.direccion = formData.nombre_sucursal;
      newFormData.nombre_sucursal = 'Sucursal principal'
    }else{
      newFormData.direccion = formData.nombre_sucursal;
    }

    newFormData.municipio = formData.municipio.value;
    newFormData.barrio = formData.barrio.value;
    newFormData.is_admin = true;

    dispatch({
      type:ActionTypes.setLoadingPage,
      data:true
    });

    AxiosInstance.post("maestros-marketplace/registro-cliente",newFormData).then( ({data})=>{
    
      if (data.status){
   
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Registro exitoso",
              message:data.msg,
              type:DialogType.exitoso,
              isVisible:true
          }
      });
      }else{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Cliente no registrado",
              message:data.msg,
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }
     

    } ).catch(error=>{

      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Error",
            message:"Error de comunicacion verifique su conexion a internet",
            type:DialogType.peligro,
            isVisible:true
        }
    });

    }).finally(()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    });



   }


   const onSearchMunicipio = async (value_search) => {

    if (value_search) {
       try{

        const { data: { value } } = await AxiosInstance.post("maestros/get-municipio-filter", {
          search_query: value_search
        });
        setCiudades(value.map( item=>({label:item.name_raw,value:item.cod,barrios:item.barrios}) ));
        return value;
       }catch(e){
        return [];
       }

    }
 }




    const configClientCreation =  {
        schemaValidator:validateDatosBasicos,
        entityValues:{
        tipo_persona:"NATURAL",
        razon_social:null,
        numero_documento:null,
        tipo_documento:null,
        correo:null,
        telefono:null,
        nombre_sucursal:null,
        municipio:null,
        direccion:null,
        clasificacion_cliente:null,
      },
        typeAction:FormActions.AGREGAR,
        titleModal: "CLIENTES",
        onSendForm:(type_action,payload)=>{
          onSendFormClient(payload);
        },
        buttomsAction:[
            /* {
              title:"Cancelar",
              buttomProps:{
                type:"button",
                onClick:()=>{
                    onCloseModal();
               
                 
                },
                color:"secondary"
            }
            }, */
            {
              title:"Guardar cambios",
              buttomProps:{
                type:"submit",
                size:"small"
              //  onClick:onSaveModData
              }
            }
        ],
        imputs:[
       /*  {
                key:"cliente",
                keyValue:"cliente",
                label:"Cliente",
                responsiveSize:12,
                callFuncionOnChange:onSearchSucursalesClientes,
                component: AutoCompleteInputWithLabel,
                    inputProps: {
                      size:"small",
                      typeInput:"autoComplete",
                     name:'cliente',
                      fullWidth: true,
                      isLoading: false,
                      //callFuncionOnChange:onSearchSucursalesClientes,
                      onInputChange: onSearchCliente,
                      options: clienteFiltro || [],
                      noOptionsText: "Lista vacia",
                      getOptionLabel: (option) => option.label,
                      isOptionEqualToValue: (option, value) => option.value === value.value,
                      filterOptions:(x) => x,
                    }
          }, */
          {
            key:"tipo_persona",
            keyValue:"tipo_persona",
            label:"Tipo de persona",
            component:SelectInputWithLabel,
            
            inputProps:{
              type:"text",
              size:"small",
              items:maestrosCompartidos?.tipo_persona
              
            }
          },
          {
            key:"razon_social",
            keyValue:"razon_social",
            label: "Nombre o Razon social",
            component:InputWithLabel,
            inputProps:{
           
              size:"small",
              type:"text",
             
            }
          },
          {
            key:"tipo_documento",
            keyValue:"tipo_documento",
            label: "Tipo de documento",
            component:SelectInputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
              items:maestrosCompartidos?.tipos_identificacion || []
             
            }
          },
          
          {
            key:"numero_documento",
            keyValue:"numero_documento",
            label: "Numero de documento",
            component:InputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
             
            }
          },
          {
            key:"telefono",
            keyValue:"telefono",
            label: "Telefono de contacto",
            responsiveSize:12,
            component:InputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
            }
          },
          {
            key: "municipio",
            keyValue: "municipio",
            label: "Ciudad",
            component: AutoCompleteInputWithLabel,
           
            callFuncionOnChange:(value,formProps)=>{
              console.log({value});
              if ( value.barrios  ){
                setBarrios(value.barrios);
                return;
              }
              formProps.setValue("barrio",null);
             
            },
            inputProps: {
              size:"small",
              name: 'municipio',
              fullWidth: true,
              isLoading: false,
              multiple:false,
              autoComplete:"off",
              PopperComponent:(props)=><div hidden={!props.open} >
               
                 {props.children}
              </div>,
              onInputChange: (e,value)=>onSearchMunicipio(value),
              options: ciudades || [],
              noOptionsText: "Lista vacia",
              getOptionLabel: (option) => option.label,
              isOptionEqualToValue: (option, value) => option.value === value.value,
              filterOptions:(x) => x,
            }
          },
          {
            key: "barrio",
            keyValue: "barrio",
            label: "Barrio",
            component: AutoCompleteInputWithLabel,
         
            inputProps: {
              size:"small",
              name: 'barrio',
              PopperComponent:(props)=><div hidden={!props.open} >
               
                 {props.children}
              </div>,
             options: barrios || [],
              noOptionsText: "Lista vacia",
  
            }
          },
          {
            key:"nombre_sucursal",
            keyValue:"nombre_sucursal",
            label:"Direccion de entrega",
            component:InputWithLabel,
            responsiveSize:12,
            inputProps:{
              size:"small",
              type:"text",
            }
          },
          {
            key:"clasificacion_cliente",
            keyValue:"clasificacion_cliente",
            label: "Tipo de cliente",
            component:SelectInputWithLabel,
            responsiveSize:12,
            inputProps:{
              size:"small",
              type:"text",
              items:maestrosCompartidos?.tipos_clientes || []
             
            }
          },
         
         
         ],
        arrayInputs:[ ],
       // FooterElement:()=><FooterElementModal config_client={configCliente}  />
      } ;

    return {
        configClientCreation
    }
}